import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { CartProvider } from '@/context/CartContext';
import { AuthProvider } from '@/context/AuthContext';
import Nav from '@/components/layout/Nav';
import Footer from '@/components/layout/Footer';
import WhatsAppFAB from '@/components/layout/WhatsAppFAB';
import ScrollToTop from '@/components/ScrollToTop';
import Home from '@/pages/Home';
import JobWork from '@/pages/JobWork';
import StandardPackage from '@/pages/StandardPackage';
import Modules from '@/pages/Modules';
import Cart from '@/pages/Cart';
import Checkout from '@/pages/Checkout';
import Estimate from '@/pages/Estimate';
import About from '@/pages/About';
import Policy from '@/pages/Policy';
import AdminLogin from '@/pages/AdminLogin';
import Admin from '@/pages/Admin';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <CartProvider>
                        <ScrollToTop />
                        <Nav />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/job-work" element={<JobWork />} />
                            <Route path="/standard-package" element={<StandardPackage />} />
                            <Route path="/pre-crafted-modules" element={<Modules />} />
                            <Route path="/modules" element={<Navigate to="/pre-crafted-modules" replace />} />
                            <Route path="/cart" element={<Cart />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/estimate" element={<Estimate />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/policy" element={<Policy />} />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="*" element={<Home />} />
                        </Routes>
                        <Footer />
                        <WhatsAppFAB />
                        <Toaster position="top-right" richColors />
                    </CartProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
